"use client";

import { useEffect } from "react";
import posthog from "posthog-js";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    posthog.capture("page_error_shown", {
      message: error.message,
      digest: error.digest,
      scope: "global",
    });
  }, [error]);

  // Inline styles: global-error replaces the root layout so globals.css and
  // next/font variables aren't loaded. Tailwind classes won't render here.
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          fontFamily:
            "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
          background: "#ffffff",
          color: "#0f172a",
        }}
      >
        <div
          style={{
            display: "flex",
            minHeight: "100vh",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            padding: "1.5rem",
            textAlign: "center",
          }}
        >
          <div style={{ maxWidth: "28rem" }}>
            <div
              style={{
                margin: "0 auto 1.5rem",
                display: "flex",
                height: "4rem",
                width: "4rem",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "9999px",
                background: "#fef2f2",
                fontSize: "1.75rem",
              }}
              aria-hidden
            >
              ⚠️
            </div>
            <h1
              style={{
                fontWeight: 700,
                fontSize: "1.5rem",
                margin: 0,
              }}
            >
              Something went wrong
            </h1>
            <p
              style={{
                marginTop: "0.75rem",
                fontSize: "0.875rem",
                lineHeight: 1.6,
                color: "#64748b",
              }}
            >
              We hit an unexpected error on our end. Our team&apos;s been
              notified and is looking into it.
            </p>
            <button
              onClick={reset}
              style={{
                marginTop: "2rem",
                borderRadius: "9999px",
                background: "#6366F1",
                color: "#ffffff",
                border: 0,
                padding: "0.75rem 2rem",
                fontSize: "0.875rem",
                fontWeight: 600,
                cursor: "pointer",
              }}
            >
              Try again
            </button>
            {error.digest ? (
              <p
                style={{
                  marginTop: "2rem",
                  fontSize: "0.75rem",
                  color: "#cbd5e1",
                }}
              >
                Reference: {error.digest}
              </p>
            ) : null}
          </div>
        </div>
      </body>
    </html>
  );
}
